
import React from 'react';
import { Button } from "@/components/ui/button";
import PaymentProcessingSteps from './PaymentProcessingSteps';
import { appConfig } from '@/config/appConfig';

interface SubmitFormButtonProps {
  isSubmitting: boolean;
  processingStep: number;
  progressValue: number;
  processingSteps: string[];
}

const SubmitFormButton: React.FC<SubmitFormButtonProps> = ({
  isSubmitting,
  processingStep,
  progressValue,
  processingSteps
}) => {
  if (!isSubmitting) {
    return (
      <Button 
        type="submit" 
        className="w-full py-6 bg-primary hover:bg-primary-dark text-white rounded-xl transition-colors duration-200 font-medium"
        disabled={isSubmitting}
      >
        Złóż zamówienie
      </Button>
    );
  }
  
  return (
    <div className="space-y-4">
      <Button 
        type="button" 
        className="w-full py-6 bg-primary/70 text-white rounded-xl font-medium cursor-not-allowed"
        disabled
      >
        Przetwarzanie...
      </Button>
      
      <PaymentProcessingSteps 
        processingStep={processingStep}
        progressValue={progressValue}
        processingSteps={processingSteps}
      />
    </div>
  );
};

export default SubmitFormButton;
